const Index = resolve => require(['@/pages/index.vue'], resolve); //首页
const About = resolve => require(['@/pages/about.vue'], resolve); //公司简介
const Advantage = resolve => require(['@/pages/advantage.vue'], resolve); //首页
const Ability = resolve => require(['@/pages/ability.vue'], resolve); //首页
const Customer = resolve => require(['@/pages/customer.vue'], resolve); //首页
const Info = resolve => require(['@/pages/info.vue'], resolve); //首页
const Contact = resolve => require(['@/pages/contact.vue'], resolve); //首页


export default {
  routes: [{
      path: '/',
      redirect: '/index',
    },
    {
      path: '/baodai',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
    {
      path: '/about/:pathId',
      name: 'about',
      component: About,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
    {
      path: '/advantage/:pathId',
      name: 'advantage',
      component: Advantage,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
    {
      path: '/ability/:pathId',
      name: 'ability',
      component: Ability,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
    {
      path: '/customer/:pathId',
      name: 'customer',
      component: Customer,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
    {
      path: '/info/:pathId',
      name: 'info',
      component: Info,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
    {
      path: '/contact/:pathId',
      name: 'contact',
      component: Contact,
      meta: {
        title: '壹心保代保险官网-让有保障的人过的更好'
      }
    },
  ]
}